import script from "./user-identification-simple.vue?vue&type=script&lang=ts&setup=true"
export * from "./user-identification-simple.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__